import React, { Component, memo, useEffect } from 'react'
import memoize from 'memoize-one'
import { FixedSizeList as List, VariableSizeList, areEqual } from 'react-window'
const { checkNameContact, checkNameUser, changeColorAva, textAva } = global.rootRequire('classes/chat')
const { rxaget, stringToColour, rxChangeSlug, subString ,changeColorSVG} = global.rootRequire('classes/ulti')

let prevArrStr = ''
let arrGroupsNChat = []
let lastUin = 0
let listMember = null

const areEqualActive = (prevProps, nextProps) => {
  try {
    let nextItem = nextProps.data.items[nextProps.index]
    let arrChecked = nextProps.data.groupsNChatChecked || []

    if (prevProps.data.items.length !== nextProps.data.items.length) {
      return false
    } else if (lastUin > 0 && nextItem.phone !== lastUin && nextProps.data.typePopup === 'leave_group') {
      return false
    } else {
      if ((arrChecked.indexOf(nextItem.phone) !== -1 && prevArrStr.indexOf(nextItem.phone) === -1) || (arrChecked.indexOf(nextItem.phone) === -1 && prevArrStr.indexOf(nextItem.phone) !== -1) ) {
        prevArrStr = nextProps.data.groupsNChatChecked.join(',')
        return false
      } else {
        return true
      }  
    }
    
  } catch(e) {
    return true
  }
}

const Row = ({ data, index, style }) => {
  const { items, toggleItemActive, groupsNChatChecked, flagCreateGroupPopup, typePopup } = data
  let groupsNChat = items
  let userObj = items[index]
  let userName = checkNameUser(groupsNChat[index])

  if (groupsNChatChecked.indexOf(groupsNChat[index].phone) !== -1 && typePopup === 'leave_group' ) {
    lastUin = groupsNChat[index].phone
  }

  return <div style={style}>
    <div key={index+''+userObj.phone}>
      {/* {(userObj.phone === -1) && <div className='zcontact_title'>{userObj.contactTitle}</div>} */}
      {(userObj.phone !== -1) && <div onClick={e => { toggleItemActive(groupsNChat[index]) }} className='group_contacts_item clearfix' >
        <div className='zgroup_avatar'>
          {groupsNChat[index].profile_url && (
            <img src={global.rxu.config.cdn_endpoint + groupsNChat[index].profile_url} alt=''
              data-id={'userava' + groupsNChat[index].phone} className='ava-useravatar images-static'
              onError={e => { e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }}
            />
          )}
          {!groupsNChat[index].profile_url && <span className='ava-span' style={{ background: `${changeColorAva(rxaget(groupsNChat, index+'.group_id', ''))}` }} >
            {textAva(rxChangeSlug(checkNameUser(groupsNChat[index])))}
          </span>}
        </div>
        <div className='zgroup_maininfo-contact'>

          {(userName.length > 38) && <div className='newgroup_userinfo_place_calendar' calendarusername-tooltip-position='right' calendarusername-tooltip={userName}> {subString(userName, 38)}  </div>} 
          {(userName.length <= 38) && <div className='newgroup_userinfo_place_calendar'> {userName} </div>} 
          {(flagCreateGroupPopup || (['add_member', 'leave_group'].indexOf(typePopup) !== -1)) &&
            <div className='newgroup_checked'>
              <label className='container100'>
                <input className='checkmark1' type='checkbox' checked={groupsNChatChecked.indexOf(groupsNChat[index]['phone']) !== -1} onChange={e => toggleItemActive(groupsNChat[index])} />
                <span className='checkmark'></span>
              </label>
            </div>
          }
        </div>
        <div className='newgroup_divider'></div>
        
      </div>}
    </div>
  </div>
}

const createItemData = (items, toggleItemActive, groupsNChatChecked, flagCreateGroupPopup, typePopup) => ({
  items,
  toggleItemActive,
  groupsNChatChecked,
  flagCreateGroupPopup,
  typePopup
})

const getItemSize = (index) => {
  let itemUser = arrGroupsNChat[index]

  // if (itemUser.phone === -1) {
  //   return 33
  // } else {
    return 60  
  // }
}

class listMemberRow extends Component {
  constructor(props, context) {
    super(props, context)
    
    this.itemData = createItemData(props.items, props.toggleItemActive, props.groupsNChatChecked, props.flagCreateGroupPopup, props.typePopup)

    arrGroupsNChat = props.items  
  }
  
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.itemData = createItemData(nextProps.items, nextProps.toggleItemActive, nextProps.groupsNChatChecked, nextProps.flagCreateGroupPopup, nextProps.typePopup)
  
    if (arrGroupsNChat.length !== nextProps.items.length && listMember) {
      listMember.resetAfterIndex(0)
    }

    arrGroupsNChat = nextProps.items
  }
  
  render() {
    return (
      <VariableSizeList
        className="add_member_contact_list"
        height={this.props.height}
        width={this.props.width}
        itemCount={this.props.items.length}
        itemData={this.itemData}
        itemSize={getItemSize}
        ref={ref => (listMember = ref)}
        onScroll={this.props.handleScrollList}
      >
        {Row}
      </VariableSizeList>
    )
  }
}

export default listMemberRow
